import { DrawerProps } from '@mantine/core';

import { Drawer } from '../drawer/drawer';

/**
 * UX wrapper for a bottom-anchored Drawer.
 * - single open/closed state is controlled by the caller
 * - close affordance is the standard Mantine "X"
 */
export function BottomSheet({
  position = 'bottom',
  withOverlay = false,
  withCloseButton = true,
  radius = 'lg',
  ...props
}: DrawerProps) {
  return (
    <Drawer
      position={position}
      radius={radius}
      withCloseButton={withCloseButton}
      withOverlay={withOverlay}
      {...props}
    />
  );
}

export default BottomSheet;

